export default __webpack_public_path__ + "static/media/user.2c81ee6d.svg";